module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Anthony C. Thiselton\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("   "), _c('B', [_vm._v("Anthony C. Thiselton")]), _vm._v(" (1937–2023) was professor of Christian theology at the University of Nottingham, England. His many books include "), _c('I', [_vm._v("A Shorter Guide to the Holy Spirit, Systematic Theology")]), _vm._v(", and "), _c('I', [_vm._v("Life after Death: A New Approach to the Last Things.")])], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/NeZGIY/MyCoverImage.jpeg?1684514755871",
      "alt": "This image is the cover for the book Discovering Romans, Discovering Biblical Texts (DBT)"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Discovering Romans, Discovering Biblical Texts (DBT)\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('i', [_vm._v("Concise, student-friendly introduction to Romans")]), _c('br'), _c('br'), _vm._v(" This third volume in the Discovering Biblical Texts series offers readers a compact, up-to-date, and student-friendly introduction to Paul's letter to the Romans, focusing on its structure, content, theological concerns, key interpretive debates, and historical reception."), _c('br'), _c('br'), _vm._v(" Anthony C. Thiselton alerts readers to key issues and questions raised by the text, encouraging in-depth study and a sincere grappling with the theological and historical questions raised by this often-controversial epistle. He pays special attention to the book's reception and its influence on Christian history and culture, exploring and explaining the approaches and conclusions of a wide range of ancient and modern interpreters."), _c('br')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Society for Promoting Christian Knowledge\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0